import _ from 'lodash'
import React, {MemoExoticComponent} from 'react';
import {useSelector} from 'react-redux';
import {AppVersionInfoButton} from 'module/TopNavBar/component/TopNavBarButton/AppVersionInfoButton';
import {TopNavBarButtonDomIDs, TopNavBarButtonID} from 'module/TopNavBar/enum/TopNavBarButtonEnums';
import {KostPanelButton} from 'module/TopNavBar/component/TopNavBarButton/KostPanelButton';
import {PersonPanelButton} from 'module/TopNavBar/component/TopNavBarButton/PersonPanelButton';
import {TopNavBarButtonGroup} from 'module/TopNavBar/component/TopNavBarButton/TopNavBarButtonGroup';
import {HamburgerPanelButton} from 'module/TopNavBar/component/TopNavBarButton/HamburgerPanelButton';
import {LabelISSPanelButton} from 'module/TopNavBar/component/TopNavBarButton/LabelISSPanelButton';
import {SettingsPanelButton} from 'module/TopNavBar/component/TopNavBarButton/SettingsPanelButton';
import {selTopNavBarButtons} from 'module/TopNavBar/selector/TopNavBarSelector'
import {TopNavBarButtonProps} from 'module/TopNavBar/component/TopNavBarButton/TopNavBarButtonComponent'

export const TopNavBarLeftButtonSection = React.memo(() => {
	const btnDefs = useSelector(selTopNavBarButtons);

	return (
		<TopNavBarButtonGroup>
			{_.map(btnDefs, (btn) => {
				let Btn: MemoExoticComponent<(props: TopNavBarButtonProps) => JSX.Element>
				switch (btn.name) {
					case TopNavBarButtonID.Hamburger:
						Btn = HamburgerPanelButton;
						break;
					case TopNavBarButtonID.Person:
						Btn = PersonPanelButton;
						break;
					case TopNavBarButtonID.Kost:
						Btn = KostPanelButton;
						break;
					case TopNavBarButtonID.Settings:
						Btn = SettingsPanelButton;
						break;
					case TopNavBarButtonID.LabelISS:
						Btn = LabelISSPanelButton;
						break;
					case TopNavBarButtonID.AppVersionInfo:
						Btn = AppVersionInfoButton;
						break;
					default:
						return null
				}
				return <Btn key={btn.name} btnDef={btn} id={TopNavBarButtonDomIDs[btn.name]}/>
			})}
		</TopNavBarButtonGroup>
	);
});